import { FormControl, FormControlLabel, FormHelperText, Switch, SwitchProps } from '@mui/material';
import { Form } from '~/shared/form/form';

type FieldSwitchProps = SwitchProps & {
	error?: boolean;
	helperText?: string;
};

export const FieldSwitch = Form.field<boolean, FieldSwitchProps>(({ field, helperText, error, readOnly, ...props }) => {
	return (
		<FormControl>
			<FormControlLabel
				label={field.label}
				control={
					<Switch
						checked={field.value ?? false}
						onChange={e => !readOnly && field.set(e.target.checked)}
						{...props}
					/>
				}
			/>
			<FormHelperText error={!!field.error || !!error}>{field.error || helperText}</FormHelperText>
		</FormControl>
	);
});
